import React from "react";

interface UserProps {
    userDetails: any;
}

const UserDetailsSection = ({ userDetails = null }: UserProps) => {
    console.log(userDetails, "userDetailsuserDetails");

    if (!userDetails) {
        return <></>;
    }
    return (
        <>
            {userDetails && (
                <div className="card border-0 shadow-sm mb-4">
                    <div className="card-header bg-white border-bottom py-3">
                        <h5 className="mb-0 fw-bold">
                            <i className="ti ti-user-circle me-2 text-primary"></i>
                            Verifier Details
                        </h5>
                    </div>

                    <div className="card-body">
                        <div className="row align-items-center gy-3">
                            {/* Avatar & Name */}
                            <div className="col-lg-4">
                                <div className="d-flex align-items-center">
                                    <div
                                        className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold me-3"
                                        style={{
                                            width: 60,
                                            height: 60,
                                            background: "#2C2F7D",
                                            fontSize: "20px",
                                        }}
                                    >
                                        {userDetails?.member_name
                                            ?.split(" ")
                                            ?.map((n: string) => n[0])
                                            ?.join("")
                                            ?.toUpperCase()}
                                    </div>

                                    <div>
                                        <h5 className="mb-1 fw-semibold">
                                            {userDetails?.member_name}
                                        </h5>

                                        <span className="badge bg-primary-subtle text-primary">
                                            Verifier
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Email */}
                            <div className="col-lg-4">
                                <div className="border rounded-3 p-3 h-100">
                                    <div className="text-dark small mb-1">
                                        <i className="ti ti-mail me-1"></i>
                                        Email
                                    </div>

                                    <div className="text-dark fw-semibold text-break">
                                        {userDetails?.member_email || "-"}
                                    </div>
                                </div>
                            </div>

                            {/* Mobile */}
                            <div className="col-lg-4">
                                <div className="border rounded-3 p-3 h-100">
                                    <div className="text-dark small mb-1">
                                        <i className="ti ti-phone me-1"></i>
                                        Mobile Number
                                    </div>

                                    <div className="text-dark fw-semibold">
                                        {userDetails?.member_phone || "-"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default UserDetailsSection;